const fr: Record<string, Record<string, string>> = {
  playerControls: {
    mute: 'Couper',
    unmute: 'Rétablir',
    play: 'Lire',
    pause: 'Suspendre'
  },
  errors: {
    noVideoId: 'Aucune Vidéo Fournie',
    noVideoDescription: 'Si vous voyez cela, veuillez contacter le support de la plate-forme.',
  }
}

export default fr;